import { render, staticRenderFns } from "./MultiLineTextView.vue?vue&type=template&id=25bc23ac"
import script from "./MultiLineTextView.vue?vue&type=script&lang=js"
export * from "./MultiLineTextView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports